import { atom, atomFamily } from 'recoil';
import { syncEffect } from 'recoil-sync';
import { string } from '@recoiljs/refine';
import WaveSurfer from 'wavesurfer.js';
import type { Region } from 'wavesurfer.js/src/plugin/regions';
import { AudioAnnotationTypes } from 'packages/main/components/audio-tool/audio-tool-types';
import { REQ_STATUS } from 'packages/lib/common-types/types';
import { AudioExtraction } from 'packages/main/components/audio-tool/api';
import type { Category } from 'packages/lib/api/annotations/contract/category';

export const audioExtractionTokenAtom = atom<string>({
  key: 'audioExtractionToken-Audio',
  default: '',
  effects: [
    // FOR RECOIL SYNC BUG WORKAROUND: see audio-tool-landing!
    syncEffect({
      itemKey: 'audioExtractionToken', // URL param name
      refine: string(),
    }),
  ],
});

export const userCanEditAtom = atom<boolean>({
  key: 'userCanEditAtom-Audio',
  default: true,
});

export const curTimeAtom = atom({
  key: 'curTimeAtom-Audio',
  default: 0,
});

export const durationAtom = atom({
  key: 'durationAtom-Audio',
  default: 0,
});

export const isPlayingAtom = atom({
  key: 'isPlayingAtom-Audio',
  default: false,
});

// Even thought there are separate regions for each waveform, only one can be selected at at time.
export const curSelectedRegionAtom = atom<Region | null>({
  key: 'curSelectedRegionAtom-Audio',
  default: null,
  dangerouslyAllowMutability: true,
});

export const curAnnotationTypesAtom = atom<AudioAnnotationTypes[]>({
  key: 'curAnnotationTypesAtom-Audio',
  default: [],
});

export const curChannelsAtom = atom<Set<number>>({
  key: 'curChannelsAtom-Audio',
  default: new Set([0, 1, 2, 3]),
});

// Store all WaveSurfer objects
export const waveSurferObjFamily = atomFamily<
  WaveSurfer | null,
  AudioAnnotationTypes
>({
  key: 'waveSurferObjFamily',
  default: null,
  dangerouslyAllowMutability: true,
});

export const categoriesAPIResultsAtom = atom<Category[] | null>({
  key: 'categoriesAPIResultsAtom',
  default: null,
});
export const categoriesAPILoadingAtom = atom<boolean>({
  key: 'categoriesAPILoadingAtom',
  default: false,
});

export const audioExtractionAPIResultAtom = atom<AudioExtraction | null>({
  key: 'audioExtractionAPIResultAtom',
  default: null,
});

export const saveToAudioApiStatusAtom = atom<REQ_STATUS>({
  key: 'saveToApiStatusAtom-Audio',
  default: REQ_STATUS.success,
});
